/**
 * The USER-SCOPED offline data, and its wipe on every session teardown.
 *
 * Intelligence > Scan's offline quotes (`features/ingest/scan/offline/scan-quotes.service.ts`) are the
 * shop's price list, stock and sales of the games downloaded for offline use, stored in IndexedDB
 * under this name with the id of the user who downloaded them. Unlike the offline CATALOGUE (company
 * data every catalogue user may read, kept on logout -- CLAUDE.md, "Offline mode") they belong to the
 * session that fetched them, as in the phone app (`quotazioni.js` `cancella`, `dimenticaDatiOperatore`):
 * logout, logout-all, the 401 bounce and back-to-login delete them.
 *
 * Lives in core and is dependency-free so `AuthService.clearSession` can call it without importing
 * the lazy Scan module. The service also checks the stored owner on every read and sync, which covers
 * an identity switch that never went through a teardown.
 */
export const SCAN_QUOTES_IDB = 'g15-scan-quotes';

/** Delete the user-scoped offline data of this origin. Fire and forget: teardown is synchronous. */
export function forgetUserOfflineData(factory: IDBFactory | null = defaultFactory()): void {
  if (!factory) {
    return;
  }
  try {
    const request = factory.deleteDatabase(SCAN_QUOTES_IDB);
    request.onerror = () => undefined;
    request.onblocked = () => undefined;
  } catch {
    // Nothing stored, or no IndexedDB at all: nothing to forget.
  }
}

function defaultFactory(): IDBFactory | null {
  try {
    return typeof indexedDB !== 'undefined' ? indexedDB : null;
  } catch {
    return null;
  }
}
